module.exports = __webpack_public_path__ + "img/unknown_Objects.c13333fa.svg";